import { FaCalendarAlt, FaUserTie, FaShoppingCart, FaEnvelope, FaTools } from 'react-icons/fa';

export const defaultFunctions = [
  {
    name: 'book_appointment',
    description: 'Schedule an appointment with available time slots',
    enabled: true,
    icon: FaCalendarAlt,
    color: 'blue',
    parameters: {
      type: "object",
      properties: {
        date: { type: "string", format: "date", description: "Appointment date (YYYY-MM-DD)" },
        time: { type: "string", format: "time", description: "Appointment time (HH:MM)" },
        service: { type: "string", description: "Type of service requested" },
        customerName: { type: "string", description: "Customer's full name" },
        customerEmail: { type: "string", format: "email", description: "Customer's email address" },
        customerPhone: { type: "string", description: "Customer's phone number" }
      },
      required: ["date", "time", "service", "customerName"]
    }
  },
  {
    name: 'transfer_to_human',
    description: 'Transfer the call to a human agent when needed',
    enabled: true,
    icon: FaUserTie,
    color: 'orange',
    parameters: {
      type: "object",
      properties: {
        reason: { type: "string", description: "Reason for transfer" },
        priority: { type: "string", enum: ["low", "medium", "high"], description: "Priority level" },
        department: { type: "string", enum: ["sales", "support", "billing"], description: "Target department" }
      },
      required: ["reason"]
    }
  },
  {
    name: 'get_order_status',
    description: 'Check the status of a customer order',
    enabled: true,
    icon: FaShoppingCart,
    color: 'green',
    parameters: {
      type: "object",
      properties: {
        orderId: { type: "string", description: "Order ID to check" },
        customerEmail: { type: "string", format: "email", description: "Customer's email for verification" }
      },
      required: ["orderId"]
    }
  },
  {
    name: 'send_email',
    description: 'Send follow-up emails to customers',
    enabled: false,
    icon: FaEnvelope,
    color: 'purple',
    parameters: {
      type: "object",
      properties: {
        recipient: { type: "string", format: "email", description: "Recipient email address" },
        subject: { type: "string", description: "Email subject line" },
        template: { type: "string", enum: ["welcome", "follow_up", "support", "pricing"], description: "Email template to use" },
        customMessage: { type: "string", description: "Custom message to include" }
      },
      required: ["recipient", "subject", "template"]
    }
  },
  {
    name: 'create_support_ticket',
    description: 'Create a support ticket for customer issues',
    enabled: true,
    icon: FaTools,
    color: 'red',
    parameters: {
      type: "object",
      properties: {
        customerEmail: { type: "string", format: "email", description: "Customer email" },
        subject: { type: "string", description: "Issue subject" },
        description: { type: "string", description: "Detailed issue description" },
        priority: { type: "string", enum: ["low", "medium", "high", "urgent"], description: "Ticket priority" },
        category: { type: "string", enum: ["technical", "billing", "general"], description: "Issue category" }
      },
      required: ["customerEmail", "subject", "description"]
    }
  }
];